import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { Language } from "../../../../shared/constants/enums";
import { LanguageService } from "../../../../shared/services/language-service";
import { ThemeService } from "../../../../shared/services/theme-service";
import { Adaa4UnreadService } from "../../services/adaa4-unread-service";

@Component({
  selector: "adaa-adaa4-header",
  imports: [RouterLink, TranslatePipe],
  templateUrl: "./adaa4-header.html",
  styleUrl: "./adaa4-header.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Adaa4HeaderComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  readonly themeService = inject(ThemeService);
  readonly languageService = inject(LanguageService);
  readonly unreadService = inject(Adaa4UnreadService);

  isDark = computed(() => this.themeService.resolved() === "dark");
  themeTarget = computed(() => (this.isDark() ? "light" : "dark"));
  logoSrc = computed(() => {
    const language = this.languageService.current() === Language.Arabic ? "_ar" : "";
    const theme = this.isDark() ? "_dark" : "";
    return `assets/images/adaa4/logo${language}${theme}.png`;
  });
  languageLabel = computed(() => (this.languageService.current() === Language.Arabic ? "English" : "العربية"));

  public ngOnInit(): void {
    this.unreadService.watch(this._destroyRef);
  }
}
